"use strict";
/// LOGGING
Object.defineProperty(exports, "__esModule", { value: true });
exports.spDebugTags = spDebugTags;
exports.spLog = spLog;
exports.spLogTags = spLogTags;
exports.spWarn = spWarn;
exports.spWarnTags = spWarnTags;
exports.spError = spError;
exports.spErrorTags = spErrorTags;
exports.spLogLvl = spLogLvl;
exports.setSpLogLvl = setSpLogLvl;
/// Default value, 0-5. 0 show all, 5 show only errors, 6 show none.
let _spLogLevel = 5;
/**
 *
 * @description Will be log level 0. Allows to add tags.
 * @description Uses default console.log props.
 * @param message
 * @param tags
 * @param optionalParams
 */
function spDebugTags(message, tags, ...optionalParams) {
    spLogLvl(0, message, tags, ...optionalParams);
}
/**
 *
 * @description Will be log level 1.
 * @description Uses default console.log props.
 * @param message
 * @param optionalParams
 */
function spLog(message, ...optionalParams) {
    spLogLvl(1, message, [], ...optionalParams);
}
/**
 *
 * @description Will be log level 1. Allows to add tags.
 * @description Uses default console.log props.
 * @param message
 * @param tags
 * @param optionalParams
 */
function spLogTags(message, tags, ...optionalParams) {
    spLogLvl(1, message, tags, ...optionalParams);
}
/**
 *
 * @description Will be log level 4.
 * @description Uses default console.log props.
 * @param message
 * @param optionalParams
 */
function spWarn(message, ...optionalParams) {
    spLogLvl(4, message, [], ...optionalParams);
}
/**
 *
 * @description Will be log level 4. Allows to add tags.
 * @description Uses default console.log props.
 * @param message
 * @param tags
 * @param optionalParams
 */
function spWarnTags(message, tags, ...optionalParams) {
    spLogLvl(4, message, tags, ...optionalParams);
}
/**
 *
 * @description Will be log level 5.
 * @description Uses default console.log props.
 * @param message
 * @param optionalParams
 */
function spError(message, ...optionalParams) {
    spLogLvl(5, message, [], ...optionalParams, '\n', new Error().stack?.split('\n')[2]);
}
/**
 *
 * @description Will be log level 5. Allows to add tags.
 * @description Uses default console.log props.
 * @param message
 * @param tags
 * @param optionalParams
 */
function spErrorTags(message, tags, ...optionalParams) {
    spLogLvl(5, message, tags, ...optionalParams, '\n', new Error().stack?.split('\n')[2]);
}
/**
 * @description Logs based on log level. Higher is more important.
 * @param level
 * @param message
 * @param optionalParams
 */
function spLogLvl(level, message, tags, ...optionalParams) {
    if (level >= _spLogLevel) {
        const whiteColour = '\x1b[37m'; /// WHITE
        let textColour = '\x1b[37m'; /// WHITE
        switch (level) {
            case 0: {
                textColour = '\x1b[32m'; /// GREEN
                break;
            }
            case 1: {
                textColour = '\x1b[36m'; /// CYAN
                break;
            }
            case 2: {
                textColour = '\x1b[34m'; /// BLUE
                break;
            }
            case 3: {
                textColour = '\x1b[90m'; /// GREY
                break;
            }
            case 4: {
                textColour = '\x1b[33m'; /// YELLOW
                break;
            }
            case 5: {
                textColour = '\x1b[31m'; /// RED
                break;
            }
        }
        const date = new Date();
        console.log(textColour + '[SPLOG] -', level, tags, date.toISOString(), whiteColour + '\x09' + message, ...optionalParams);
    }
}
/**
 * @description Set log level. 0 to see all. 5 to only see errors. 6 to see nothing.
 * @param level 1 to 5
 */
function setSpLogLvl(level) {
    _spLogLevel = level;
}
